export function invariant(condition: unknown, message: string): asserts condition {
  if (!condition) {
    throw new Error(message);
  }
}

export function createId(prefix: string, value: string) {
  return `${prefix}-${value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')}`;
}

/** Compare raw table values, keeping missing/non-finite values last in either direction. */
export function compareNullableValues(
  left: string | number | null | undefined,
  right: string | number | null | undefined,
  descending = false,
): number {
  const leftMissing = left == null || (typeof left === 'number' && !Number.isFinite(left));
  const rightMissing = right == null || (typeof right === 'number' && !Number.isFinite(right));
  if (leftMissing) return rightMissing ? 0 : 1;
  if (rightMissing) return -1;
  const compared =
    typeof left === 'number' && typeof right === 'number'
      ? left - right
      : String(left).localeCompare(String(right), undefined, {
          numeric: true,
          sensitivity: 'base',
        });
  return descending ? -compared : compared;
}
